const PREFIX = "theme/";
export const SET_THEME = `${PREFIX}SET_THEME`;
